module.exports = __webpack_public_path__ + "img/money_pop.73309799.png";